<template>
  <div v-show="isBusy" id="" class="h-100" :class="{ loading: isBusy }">
    <div class="loading-dots">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BusySpinner',
  computed: {
    isBusy() {
      return this.$store.state.isBusy;
    },
  },
};
</script>

<style lang="scss">
@import '../scss/loading';

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #6f42c1;
  margin-top: 0px;
}
</style>
